import { render, staticRenderFns } from "./DispatchLetter.vue?vue&type=template&id=8a74717e"
import script from "./DispatchLetter.vue?vue&type=script&lang=js"
export * from "./DispatchLetter.vue?vue&type=script&lang=js"
import style0 from "./DispatchLetter.vue?vue&type=style&index=0&id=8a74717e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports